/**
 * Local IndexedDB cache for generated portfolio PDFs (this browser only).
 */

const DB_NAME = "manage360-portfolio-reports";
const STORE = "reports";
const VERSION = 1;

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, VERSION);
    req.onerror = () => reject(req.error);
    req.onsuccess = () => resolve(req.result);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE)) {
        db.createObjectStore(STORE, { keyPath: "id" });
      }
    };
  });
}

/**
 * @param {object} p
 * @param {string} p.rootCategoryId
 * @param {string} p.rootName
 * @param {string} p.mode
 * @param {string} p.categoryIdsKey — stable key for “same selection”
 * @param {Blob} p.blob
 * @param {object} [p.reportData] — optional JSON snapshot for reference
 */
export async function savePortfolioReport(p) {
  const db = await openDb();
  const id =
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `r-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
  const entry = {
    id,
    createdAt: Date.now(),
    rootCategoryId: String(p.rootCategoryId),
    rootName: String(p.rootName || ""),
    mode: String(p.mode || "summary"),
    categoryIdsKey: String(p.categoryIdsKey || ""),
    blob: p.blob,
    reportData: p.reportData || null,
  };
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.objectStore(STORE).put(entry);
  });
  db.close();
  return id;
}

export async function listPortfolioReportsForRoot(rootCategoryId) {
  const db = await openDb();
  const all = await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readonly");
    const r = tx.objectStore(STORE).getAll();
    r.onsuccess = () => resolve(r.result || []);
    r.onerror = () => reject(r.error);
  });
  db.close();
  const rid = String(rootCategoryId);
  return all
    .filter((x) => String(x.rootCategoryId) === rid)
    .sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
}

export async function deletePortfolioReport(id) {
  const db = await openDb();
  await new Promise((resolve, reject) => {
    const tx = db.transaction(STORE, "readwrite");
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
    tx.objectStore(STORE).delete(id);
  });
  db.close();
}

export function openPdfBlobInNewTab(blob) {
  const url = URL.createObjectURL(blob);
  const w = window.open(url, "_blank", "noopener,noreferrer");
  if (w) {
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } else {
    URL.revokeObjectURL(url);
  }
}

export function downloadPdfBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName || "report.pdf";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
